import { Pipe, PipeTransform } from '@angular/core';
import { WorkshopJob } from '../../models/workshop-job';
import { Item } from '../../models';
import { CustomerEquipment } from '../../models/customer-equipment';

@Pipe({
    name: 'workshopJobName',
    standalone: true
})
export class WorkshopJobNamePipe implements PipeTransform {
  transform(value: WorkshopJob<any>, ...args: unknown[]): string {
    const prefix = `${value.type} of `;
    if (value.repairable_type === 'item') {
      return `${prefix}${(value.repairable as Item).code}`;
    }
    if (value.repairable_type === 'customerEquipment') {
      return `${prefix}${(value.repairable as CustomerEquipment).name}`;
    }
  }
}
